import React from "react";
import SubscriptionsSlaUpgradeAlert from "./subscriptionsSlaUpgradeAlert";
import SubscriptionsBrandingEnableAlert from "./subscriptionsBrandingEnableAlert";
import {
  getSubscriptionsEnabled,
  isSubscriptionsSlaEligible,
} from "../utils/subscriptionUtils";

const SubscriptionsFeatureLockAlerts = ({ tenant, slaLevel }) => {
  const slaEligible = isSubscriptionsSlaEligible(slaLevel);
  const subscriptionsEnabled = getSubscriptionsEnabled(tenant);

  if (!slaEligible) {
    return <SubscriptionsSlaUpgradeAlert />;
  }

  if (!subscriptionsEnabled) {
    return <SubscriptionsBrandingEnableAlert />;
  }

  return null;
};

export default SubscriptionsFeatureLockAlerts;
